import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from '../../helper/AxiosInstance'
import { countryCallingCodes, Validation, searchCountry } from '../../helper/function'

function UpcomingEvents() {
   const [times, setTimes] = useState([]);
   const [countrys, setCountrys] = useState(countryCallingCodes)
   const [calendar, setCalendar] = useState({ minDate: new Date(), maxDate: null, value: null, display: '' });
   const [data, setData] = useState({ fullName: '', email: '', phone: '', meetingDate: '', companyName: '', website: '', companySize: '', message: '', platform: '', searchCountry: '', countryCode: '+91', country: 'India' });
   const [isLoading, setIsLoading] = useState(false);
   const [ReactCalendar, setReactCalendar] = useState(null)

   const handleInputChange = (event) => {
   Validation(event);

      const target = event?.currentTarget;
      if (!target) {
         if (event instanceof Date) {
            setCalendar(prev => ({ ...prev, value: event, display: '' }));
            return;
         }

         if (event?.value) {
            const selectedTime = new Date(event.value);
            const formatted = `${selectedTime.getFullYear()}-${(selectedTime.getMonth() + 1)
               .toString()
               .padStart(2, '0')}-${selectedTime.getDate()
                  .toString()
                  .padStart(2, '0')}T${selectedTime.getHours()
                     .toString()
                     .padStart(2, '0')}:${selectedTime.getMinutes()
                        .toString()
                        .padStart(2, '0')}`;
            setCalendar(prev => ({ ...prev, display: formatted }));
            setData(prev => ({ ...prev, meetingDate: selectedTime }));
            return;
         }
         return;
      }
      setData(prev => ({ ...prev, [target.name]: target.value }));
   };

   const submitForm = async (e) => {
      e.preventDefault();
      setIsLoading(true);

      if (!data.meetingDate) {
         toast.warn('Please Select Meeting Date.');
         setIsLoading(false);
         return;
      }

      try {
         const res = await axiosInstance.post("/public/meeting-scheduler", data);
         if (res.data.status === 'success') {
            setCalendar(prev => ({
               ...prev,
               minDate: new Date(),
               maxDate: null,
               value: null,
               display: ''
            }));
            setData({
               fullName: '',
               email: '',
               phone: '',
               meetingDate: '',
               companyName: '',
               website: '',
               companySize: '',
               message: '',
               platform: ''
            });
            await toast.warn({ title: "Success", text: res.data.message, icon: "success" });
         } else {
            toast.warn(res.data.message);
         }
      } catch (err) {
         toast.error(err.message);
      } finally {
         setIsLoading(false);
      }
   };

   useEffect(() => {
      const startDate = new Date();
      const endDate = new Date();
      endDate.setMonth(endDate.getMonth() + 1);
      setCalendar(prev => ({ ...prev, minDate: startDate, maxDate: endDate }));

      if (calendar?.value) {
         const currentDate = new Date(calendar.value);
         const newTimes = [];
         let nextHalfHour = new Date(currentDate);
         nextHalfHour.setHours(0, 0, 0, 0);

         const endOfDay = new Date(currentDate);
         endOfDay.setHours(23, 59, 59, 999);

         if (currentDate.toDateString() === new Date().toDateString()) {
            const now = new Date();
            if (nextHalfHour < now) {
               nextHalfHour.setMinutes(Math.ceil(now.getMinutes() / 30) * 30);
               nextHalfHour.setSeconds(0);
               nextHalfHour.setMilliseconds(0);
            }
         }

         while (nextHalfHour <= endOfDay) {
            if (nextHalfHour.getTime() - currentDate.getTime() >= 30 * 60 * 1000) {
               const timeString = nextHalfHour.toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: true
               });
               newTimes.push({ value: new Date(nextHalfHour), label: timeString });
            }
            nextHalfHour.setMinutes(nextHalfHour.getMinutes() + 30);
         }

         setTimes(newTimes);
      }
   }, [calendar?.value]);
   useEffect(() => {
      setCountrys(countryCallingCodes.filter(cty => cty.name.toLowerCase().includes(data.searchCountry.toLowerCase()) || cty.code.toLowerCase().includes(data.searchCountry.toLowerCase())))
   }, [data.searchCountry])

   useEffect(()=>{
      import('react-calendar').then((module)=>{
         setReactCalendar(()=>module.Calendar)

      }).catch((err)=>{})
   },[])
   if (!ReactCalendar) { return null }
   return (
      <>
         <Helmet>
            <title>Upcoming Events Taskflier</title>
         </Helmet>

        
           
            <div className="fancy-feature-twentyNine lg-container bg-white pt-40" id="p-tour">
               <div className="container">
                  <div className="block-style-thirty bottom-border pb-80 mb-70 md-pb-40 md-mb-90">
                     <div className="row">
                        <div className="col-xl-5 col-lg-6">
                           <div className="text-wrapper">
                              <div className="feature">Upcoming Event</div>
                              <div className="title-style-twelve">
                                 <h2 className="maintitle font-26 mb-4">Make a call to a product expert</h2>
                                 <p className="mainp">Give your employee a better way to improve external and internal management that drives your business success.</p>
                                 <ul className="mobli mt-2">
                                    <li className="zoom"><i className="bi bi-clock green"></i> Meeting Time : 30 min</li>
                                 </ul>
                              </div>
                              <img src="/images/google-meet.jpg" alt="" className="text-block md-pb-60" />
                           </div>
                        </div>

                        <div className="col-xl-7 col-lg-6">
                           <div className="req-bg" style={{ background: "#f0f6fc" }}>
                              <p className="text-center text-black fs-16 fw-500 mb-3">Don’t miss out on the latest industry trends</p>
                              <form onSubmit={submitForm} className="submitrequest">
                                 <div className="row controls">
                                    <div className="col-6">
                                       <div className="input-group-meta form-group mb-15">
                                          <label>Full Name <span className="text-danger">*</span></label>
                                          <input data-type="name" type="text" name="fullName" placeholder="Enter your name" value={data.fullName} onChange={handleInputChange} required />
                                       </div>
                                    </div>

                                    <div className="col-6">
                                       <div className="input-group-meta form-group mb-15">
                                          <label>Email <span className="text-danger">*</span></label>
                                          <input data-type="email" type="text" name="email" placeholder="Enter your email" value={data.email} onChange={handleInputChange} required />
                                       </div>
                                    </div>

                                    <div className="col-6">
                                       <div className="input-group-meta form-group mb-1"><label>Phone <span class="text-danger">*</span></label>


                                          <div className="input-group contactvalid">

 <button class="input-group-text dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">{data?.countryCode || 'Code'}</button>

                                             <ul class="dropdown-menu country-filter">

                                                <li style={{ cursor: "pointer" }} className="search-menu" >

                                                   <span class="dropdown-item"> <i class="bi bi-search icon-search"></i>
                                                      <input data-type="name" className="form-control form-control-sm search-bar" name="searchCountry" placeholder="Search Country" value={data.searchCountry} onInput={handleInputChange} /></span>
                                                </li>
                                                {(countrys || []).map((cty) => { return (<li onClick={() => { setData((prev) => ({ ...prev, searchCountry: '', countryCode: cty.code, country: cty.name })) }}><span class="dropdown-item">{cty.name}</span></li>) })}
                                             </ul>

                                             <input data-type="mobile" class="form-control" name="mobile" id="monile" type="text" placeholder="enter mobile no" value={data.mobile} onInput={handleInputChange} required />


                                          </div>


                                       </div>
                                    </div>

                                    <div className="col-6">
                                       <div className="input-group-meta form-group mb-15">
                                          <label>Select a Date <span className="text-danger">*</span></label>
                                          <input type="datetime-local" value={calendar?.display} readOnly data-bs-toggle="modal" data-bs-target="#DateTime" required />
                                       </div>
                                    </div>

                                    <div className="col-12">
                                       <div className="input-group-meta form-group mb-15">
                                          <label>Company Name</label>
                                          <input name="companyName" type="text" placeholder="Enter company name" value={data.companyName} onChange={handleInputChange} />
                                       </div>
                                    </div>

                                    <div className="col-6">
                                       <div className="input-group-meta form-group mb-15">
                                          <label>Website</label>
                                          <input name="website" type="text" placeholder="www.example.com" value={data.website} onChange={handleInputChange} />
                                       </div>
                                    </div>

                                    <div className="col-6">
                                       <div className="input-group-meta form-group mb-15">
                                          <label>Company Size</label>
                                          <select name="companySize" className="form-select" value={data.companySize} onChange={handleInputChange}>
                                             <option value="">Company Size</option>
                                             <option value="1-5">1-5 employees</option>
                                             <option value="5-20">5-20 employees</option>
                                             <option value="20-50">20-50 employees</option>
                                             <option value="50-250">50-250 employees</option>
                                             <option value="+250">+250 employees</option>
                                          </select>
                                       </div>
                                    </div>

                                    <div className="col-12">
                                       <div className="input-group-meta form-group mb-2">
                                          <label>Describe your needs *</label>
                                          <textarea name="message" placeholder="Write your message here..." className="heightmessage" value={data.message} onChange={handleInputChange}></textarea>
                                       </div>
                                    </div>

                                    <p className="fs-12 privacy">When you submit this form, you are consenting to our <a href="/privacy-policy" className="text-primary">Privacy Policy</a>.</p>

                                    <div className="col-12">
                                       {isLoading ? (
                                          <button type="button" className="theme-btn-seven w-100 themebutton" disabled>
                                             <div className="spinner-border" role="status" style={{ borderWidth: '1px', height: '1.5rem', width: '1.5rem' }}></div>
                                          </button>
                                       ) : (
                                          <button type="submit" className="btn theme-btn-seven w-100 themebutton" disabled={!data.meetingDate}>Submit</button>
                                       )}
                                    </div>
                                 </div>
                              </form>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div className="modal fade" id="DateTime" tabIndex="-1" aria-labelledby="DateTimeLabel" aria-hidden="true">
                     <div className="modal-dialog modal-lg modal-event modal-dialog-centered">
                        <div className="modal-content">
                           <div className="modal-header">
                              <h1 className="modal-title fs-5" id="DateTimeLabel">Select a Date & Time</h1>
                              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                           </div>
                           <div className="modal-body">
                              <div className="row">
                                 <div className={calendar?.value ? "col-md-7" : "col-md-12"}>
                                    <ReactCalendar value={calendar?.value} minDate={calendar?.minDate} maxDate={calendar?.maxDate} onChange={handleInputChange} />
                                 </div>
                                 {calendar?.value && (
                                    <div className="col-md-5">
                                       <p className="mainp">{calendar?.value?.toDateString()}</p>
                                       <ul className="mobli mt-2 meetingdate">
                                          {times.map((time, idx) => (
                                             <li
                                                key={idx}
                                                className={`zoom px-2 py-2 mb-2 text-center${time.value.getTime() === new Date(data.meetingDate).getTime() ? " active-time" : ""}`}
                                                onClick={() => handleInputChange(time)}
                                             >
                                                {time.label}
                                             </li>
                                          ))}
                                       </ul>
                                    </div>
                                 )}
                              </div>
                           </div>
                           <div className="modal-footer">
                              <button type="button" className="btn red text-white" data-bs-dismiss="modal"
                                 onClick={() => {
                                    setCalendar(prev => ({ ...prev, value: null, display: '' }));
                                    setData(prev => ({ ...prev, meetingDate: '' }));
                                 }}
                              >
                                 Close
                              </button>
                              {data.meetingDate && <button type="button" className="btn green text-white" data-bs-dismiss="modal">Next</button>}
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
          
      </>
   );
}

export default UpcomingEvents;
